import { ITEM_RARITIES, type ItemRarity } from "odyssey-shared";
import { rarityColour } from "../../item-card/card-colours.ts";

/**
 * The colour of a ground item's label (P2.8-T76): its rarity's colour as the bag's slots and the item card take it
 * (`rarityColour`, ADR-125 decision 1.3: Epic the design's Very Rare, Relic its stand-in). The tints are made once, so
 * choosing one allocates nothing.
 */

/**
 * Each rarity's tint, made once.
 */
const TINTS: Readonly<Record<ItemRarity, number>> = Object.freeze(Object.fromEntries(ITEM_RARITIES.map((rarity) => [rarity, Number.parseInt(rarityColour(rarity).slice(1), 16)])) as Record<ItemRarity, number>);

/**
 * A rarity's tint.
 *
 * @param rarity The rarity.
 * @returns The tint, the rarity's colour as a number.
 * @example
 * rarityTint("rare");
 * // 0x5aa8ff
 */
export function rarityTint(rarity: ItemRarity): number {
  return TINTS[rarity];
}
